export const LimitColor = {
  GREEN: 'green',
  YELLOW: 'yellow',
  RED: 'red'
};
